import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../environments/environment';
import { BackLinkComponent } from '../../shared/components/back-link/back-link.component';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';

interface JobDetail {
  id: number;
  job_type: string;
  entity_type: string | null;
  entity_id: number | null;
  status: string;
  message: string | null;
  attempt_count: number;
  system_prompt: string | null;
  user_prompt: string | null;
  llm_output: string | null;
  created_at: string | null;
  completed_at: string | null;
}

@Component({
  selector: 'app-job-detail',
  templateUrl: './job-detail.component.html',
  styleUrls: ['./job-detail.component.scss'],
  standalone: true,
  imports: [
    CommonModule, RouterModule, DatePipe,
    MatButtonModule, MatIconModule,
    BackLinkComponent, LoadingSpinnerComponent,
  ],
})
export class JobDetailComponent implements OnInit {
  job: JobDetail | null = null;
  isLoading = true;
  errorMessage: string | null = null;

  constructor(private http: HttpClient, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.http.get<JobDetail>(`${environment.apiUrl}/jobs/${id}`).subscribe({
      next: (data) => {
        this.job = data;
        this.isLoading = false;
      },
      error: () => {
        this.errorMessage = 'Job not found.';
        this.isLoading = false;
      },
    });
  }

  statusClass(status: string): string {
    switch (status) {
      case 'complete':    return 'status-complete';
      case 'running':     return 'status-running';
      case 'queued':      return 'status-queued';
      case 'failed':      return 'status-failed';
      case 'dead_letter': return 'status-dead';
      default:            return '';
    }
  }
}
